export interface ActivityType {
  name: string;
  icon: string;
  defaultDuration: number;
  description: string;
  category: 'In-Person' | 'Remote' | 'Shared Activity' | 'Special';
}

export const ACTIVITY_TYPES: ActivityType[] = [
  {
    name: 'Coffee/Tea',
    icon: 'Coffee',
    defaultDuration: 60,
    description: 'A casual catch-up over a warm drink',
    category: 'In-Person'
  },
  {
    name: 'Meal',
    icon: 'UtensilsCrossed',
    defaultDuration: 90,
    description: 'Sharing a meal together',
    category: 'In-Person'
  },
  {
    name: 'Walk',
    icon: 'Footprints',
    defaultDuration: 45,
    description: 'A walk together, great for conversation',
    category: 'In-Person'
  },
  {
    name: 'Hangout',
    icon: 'Sofa',
    defaultDuration: 120,
    description: 'Casual time spent together',
    category: 'In-Person'
  },
  {
    name: 'Visit',
    icon: 'Home',
    defaultDuration: 120,
    description: 'Visiting someone at their home',
    category: 'In-Person'
  },

  {
    name: 'Phone Call',
    icon: 'Phone',
    defaultDuration: 30,
    description: 'A voice call',
    category: 'Remote'
  },
  {
    name: 'Video Call',
    icon: 'Video',
    defaultDuration: 45,
    description: 'Face-to-face connection from anywhere',
    category: 'Remote'
  },
  {
    name: 'Text Chat',
    icon: 'MessageSquare',
    defaultDuration: 15,
    description: 'A meaningful text conversation',
    category: 'Remote'
  },
  {
    name: 'Voice Message',
    icon: 'Mic',
    defaultDuration: 10,
    description: 'Exchanging voice messages',
    category: 'Remote'
  },

  {
    name: 'Workout',
    icon: 'Dumbbell',
    defaultDuration: 60,
    description: 'Exercising together',
    category: 'Shared Activity'
  },
  {
    name: 'Game Night',
    icon: 'Gamepad2',
    defaultDuration: 120,
    description: 'Playing games together',
    category: 'Shared Activity'
  },
  {
    name: 'Movie/Show',
    icon: 'Film',
    defaultDuration: 120,
    description: 'Watching something together',
    category: 'Shared Activity'
  },
  {
    name: 'Sports',
    icon: 'Trophy',
    defaultDuration: 90,
    description: 'Playing or watching sports together',
    category: 'Shared Activity'
  },
  {
    name: 'Hobby Session',
    icon: 'Palette',
    defaultDuration: 90,
    description: 'Sharing a hobby or creative activity',
    category: 'Shared Activity'
  },
  {
    name: 'Learning Together',
    icon: 'BookOpen',
    defaultDuration: 60,
    description: 'Learning or studying together',
    category: 'Shared Activity'
  },
  {
    name: 'Work Session',
    icon: 'Laptop',
    defaultDuration: 120,
    description: 'Working alongside each other',
    category: 'Shared Activity'
  },

  {
    name: 'Party/Event',
    icon: 'PartyPopper',
    defaultDuration: 180,
    description: 'Attending or hosting an event together',
    category: 'Special'
  },
  {
    name: 'Trip/Travel',
    icon: 'Plane',
    defaultDuration: 480,
    description: 'Traveling together',
    category: 'Special'
  },
  {
    name: 'Celebration',
    icon: 'Gift',
    defaultDuration: 120,
    description: 'Celebrating a milestone or occasion',
    category: 'Special'
  },
  {
    name: 'Support Session',
    icon: 'Heart',
    defaultDuration: 60,
    description: 'Being there for someone in need',
    category: 'Special'
  },
  {
    name: 'Deep Conversation',
    icon: 'MessageCircleHeart',
    defaultDuration: 90,
    description: 'A meaningful, vulnerable discussion',
    category: 'Special'
  },
  {
    name: 'Meeting',
    icon: 'Briefcase',
    defaultDuration: 60,
    description: 'A professional meeting or discussion',
    category: 'Special'
  },
  {
    name: 'Other',
    icon: 'MoreHorizontal',
    defaultDuration: 60,
    description: 'Another type of interaction',
    category: 'Special'
  }
];

export const ACTIVITY_CATEGORIES = ['In-Person', 'Remote', 'Shared Activity', 'Special'] as const;

export function getActivityType(name: string): ActivityType | undefined {
  return ACTIVITY_TYPES.find(at => at.name === name);
}

export function getActivityTypesByCategory(category: string): ActivityType[] {
  return ACTIVITY_TYPES.filter(at => at.category === category);
}

export function calculatePointsFromDuration(durationMinutes: number): number {
  const points = Math.round((durationMinutes / 60) * 3);
  return Math.max(1, Math.min(12, points));
}
